import {HttpClient, HttpParams} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {REMIT_BASE_URL} from './config';

export interface CreateStaffAdminApiKeyRequest {
  name: string;
  clientId: string;
  description?: string;
  expiresAt?: string;
}

export interface StaffAdminApiKey {
  id: string;
  name: string;
  key?: string;
  clientId: string;
  description: string;
  createdAt: string;
  expiresAt: string;
  lastUsedAt?: string;
  isActive: boolean;
}

export interface StaffAdminApiKeyListQuery {
  page?: number;
  pageSize?: number;
}

export interface StaffAdminApiKeyListResponse {
  items: StaffAdminApiKey[];
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

export interface StaffAdminApiKeyErrorResponse {
  error: string;
}

export interface RevokeStaffAdminApiKeyResponse {
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class StaffAdminApiKeyService {
  constructor(
    private http: HttpClient,
    @Inject(REMIT_BASE_URL) private remitApiUrl: string,
  ) {}

  createApiKey(
      body: CreateStaffAdminApiKeyRequest,
  ): Observable<StaffAdminApiKey> {
    return this.http.post<StaffAdminApiKey>(
        `${this.remitApiUrl}/staff/admin/api-keys`,
        body,
    );
  }

  getApiKeys(
      query: StaffAdminApiKeyListQuery = {},
  ): Observable<StaffAdminApiKeyListResponse> {
    return this.http.get<StaffAdminApiKeyListResponse>(
        `${this.remitApiUrl}/staff/admin/api-keys`,
        {params: this.buildParams(query)},
    );
  }

  getApiKeysByClientId(
      clientId: string,
      query: StaffAdminApiKeyListQuery = {},
  ): Observable<StaffAdminApiKeyListResponse> {
    const encodedClientId = encodeURIComponent(clientId);

    return this.http.get<StaffAdminApiKeyListResponse>(
        `${this.remitApiUrl}/staff/admin/api-keys/client/${encodedClientId}`,
        {params: this.buildParams(query)},
    );
  }

  revokeApiKey(keyId: string): Observable<RevokeStaffAdminApiKeyResponse> {
    const encodedKeyId = encodeURIComponent(keyId);

    return this.http.delete<RevokeStaffAdminApiKeyResponse>(
        `${this.remitApiUrl}/staff/admin/api-keys/${encodedKeyId}`,
    );
  }

  private buildParams(query: StaffAdminApiKeyListQuery): HttpParams {
    let params = new HttpParams();

    Object.entries(query).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        return;
      }

      params = params.set(key, String(value));
    });

    return params;
  }
}
